import React, { Fragment } from 'react';
import { Row, Col } from 'reactstrap';
import { PageAnimation } from '../../Layout/Components/Animation';
import PageTitle from '../../Layout/Components/PageTitle';

import Strings from '../../translations/Translations';
import ListCampaignsModule from '../../modules/campaign/list/ListCampaignsModule';

export default function ListCampaigns() {
  return (
    <Fragment>
      <PageAnimation>
        <PageTitle
          heading={Strings('campaigns')}
          subheading={Strings('list_of_your_campaigns')}
          icon="pe-7s-display1"
        />

        <Row>
          <Col>
            <ListCampaignsModule />
          </Col>
        </Row>
      </PageAnimation>
    </Fragment>
  );
}
